import ActionType from 'actions/ActionType'

export default (state = 0, action) => {
  switch (action.type) {
    case ActionType.SignupForm.TOGGLE_BOTTOM_NAV:
      return action.payload
    default:
      return state
  }
}
